/**
 * ForgotPasswordForm - Forgot password flow
 */
import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { useAuth } from '../../hooks/useAuth';
import { useAuthForm } from '../../hooks/useAuthForm';
import { AUTH_MODES, INPUT_TYPES } from '../../types';
import { AuthHeader, AuthInput, AuthButton } from '../ui';

function ForgotPasswordForm() {
  const { loading, otpSent, switchMode, setMode } = useAuthContext();
  const { sendForgotPasswordOtp } = useAuth();
  const { 
    identifier, 
    identifierType,
    error, 
    handleIdentifierChange,
    isIdentifierValid,
  } = useAuthForm();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isIdentifierValid()) return;
    
    const success = await sendForgotPasswordOtp();
    if (success) {
      setMode(AUTH_MODES.RESET_PASSWORD);
    }
  };
  
  return (
    <div className="relative p-6 md:p-8 bg-white">
      <AuthHeader
        title="Forgot Password?"
        subtitle="Enter your mobile number or email to receive a reset OTP"
        showBack
        onBack={() => switchMode(AUTH_MODES.LOGIN)}
      />
      
      <form onSubmit={handleSubmit} className="space-y-5">
        <AuthInput
          label="Mobile Number or Email"
          type={identifierType === INPUT_TYPES.MOBILE ? 'tel' : 'text'}
          value={identifier}
          onChange={handleIdentifierChange}
          placeholder="Enter mobile number or email"
          error={error}
          disabled={loading}
          autoFocus
          maxLength={identifierType === INPUT_TYPES.MOBILE ? 10 : 50}
          icon={
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          }
        />
        
        <AuthButton
          type="submit"
          loading={loading}
          disabled={!isIdentifierValid()}
        >
          Send Reset OTP
        </AuthButton>
      </form>
      
      {/* Back to Login */}
      <div className="mt-6 text-center">
        <button
          type="button"
          onClick={() => switchMode(AUTH_MODES.LOGIN)}
          className="text-sm text-gray-500 hover:text-[#004171] transition-colors"
        >
          Remember your password?{' '}
          <span className="font-medium text-[#004171]">Login</span>
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
